import React from 'react'
import Link from 'next/link'

import { Text } from '@wartek-id/text'

import Header from 'app/BuktiKaryaPage/components/Header'
import { useBCKSDesktopView } from 'app/BCKSPage/hooks/useBCKSDesktopView'
import { BCKSDesktopPageShell } from 'app/BCKSPage/components/BCKSDesktopPageShell'
import { documentMap } from './guideData'

export const BCKSInvitationGuide = () => {
  const { isDesktop } = useBCKSDesktopView()

  if (isDesktop) {
    return (
      <BCKSDesktopPageShell title="Panduan Dokumen" pageLabel="Panduan Dokumen">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Object.keys(documentMap).map((key) => {
            return (
              <section
                key={key}
                className="flex flex-col justify-between w-full bg-white p-5 rounded-lg border border-border-subdued"
              >
                <div>
                  <Text variant="heading-sm">{documentMap[key].title}</Text>
                  <Text color="subdued" className="mt-2">
                    {documentMap[key].subTitle}
                  </Text>
                </div>
                <Link passHref href={`/bcks/invitation/guide/${key}`}>
                  <a className="mt-4">
                    <Text
                      variant="body-sm"
                      style={{ fontWeight: 'bold' }}
                      color="primary"
                      className="cursor-pointer"
                    >
                      {documentMap[key].actionText}
                    </Text>
                  </a>
                </Link>
              </section>
            )
          })}
        </div>
      </BCKSDesktopPageShell>
    )
  }

  return (
    <div className="relative flex flex-col h-screen max-w-xl mx-auto">
      <Header title="Panduan Dokumen" forceNavigateBack />
      {/* TODO: @egi uncomment when link ready */}
      {/* {props.isPaktaIntegritasEnabled && (
        <div className="bg-surface-selected-default p-4 flex flex-col gap-4">
          <Text variant="body-sm">
            Catatan: Baca petunjuk teknis untuk info dokumen selengkapnya
          </Text>
          <Link passHref href={`#`}>
            <a>
              <Text
                variant="action"
                style={{ fontWeight: 'bold' }}
                color="primary"
                className="cursor-pointer"
              >
                Baca Petunjuk Teknis
              </Text>
            </a>
          </Link>
        </div>
      )} */}

      {Object.keys(documentMap).map((key) => {
        return (
          <section
            key={key}
            className="flex flex-col w-full bg-white p-4 border-b border-subdued"
          >
            <Text variant="heading-sm">{documentMap[key].title}</Text>
            <Text color="subdued" className="my-2">
              {documentMap[key].subTitle}
            </Text>
            <Link passHref href={`/bcks/invitation/guide/${key}`}>
              <a>
                <Text
                  variant="body-sm"
                  style={{ fontWeight: 'bold' }}
                  color="primary"
                  className="cursor-pointer"
                >
                  {documentMap[key].actionText}
                </Text>
              </a>
            </Link>
          </section>
        )
      })}
    </div>
  )
}
